module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dados.anais_cor_bg_menus == null || _vm.dados.anais_cor_bg_menus == '' || !_vm.dados.anais_cor_bg_menus) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n          " + _vm._s(_vm._f("capitalize")(_vm.$t('inicio'))) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-home"
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/corpo_editorial"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('corpo_editorial')) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-book"
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/autores"
    }
  }, [_vm._v("\n          " + _vm._s(_vm._f("capitalize")(_vm.$tc('autor', 2))) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-users"
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/eixos"
    }
  }, [_vm._v("\n          " + _vm._s(_vm._f("capitalize")(_vm.$tc('eixo', 2))) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/trabalhos"
    }
  }, [_vm._v("\n          " + _vm._s(_vm._f("capitalize")(_vm.$tc('trabalho', 2))) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-pencil"
  })])], 1)])])]) : _c('div', {
    staticClass: "col-md-12"
  }, [_c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$t('inicio'))) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/corpo_editorial"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$t('corpo_editorial'))) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/autores"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$tc('autor', 2))) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/eixos"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$tc('eixo', 2))) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/trabalhos"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$tc('trabalho', 2))) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1023aae3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/anais/AnaisHeader.vue
// module id = 206
// module chunks = 0